// extracted by mini-css-extract-plugin
module.exports = {"chipsContainer":"SwitchFilters_chipsContainer__l_Kn4","chipsRow":"SwitchFilters_chipsRow__w8BUv","chip":"SwitchFilters_chip__jsczh"};